export default __webpack_public_path__ + "static/SR India - FSSAI Import license - Certificate-99afce68396a9850015ae747d377c14e.pdf";